// hooks/order-summary/useCartManagement.ts
import { useCartState } from "./useCartState";
import { useCartActions } from "./../../../home/hooks/order-summary/useCartActions";
import { useCartCalculations } from "./../../../home/hooks/order-summary/useCartCalculations";
import React, { useEffect, useCallback } from "react";

export const useCartManagement = () => {
  const { 
    selectedProductslist, 
    setSelectedProductslist, 
    valueMap, 
    setValueMap, 
    condition, 
    setCondition, 
    deliveryFee, 
    setDeliveryFee 
  } = useCartState();

  // Store edited amounts separately by productId
  const [editedAmounts, setEditedAmounts] = React.useState<{ [productId: string]: string }>({});

  const { totalQuantity, totalAmount, disValue, grandTotal } = useCartCalculations(
    selectedProductslist, 
    valueMap, 
    condition, 
    deliveryFee,
    editedAmounts // Pass edited amounts to calculations
  );

  const { addProductToCart, removeProductFromCart, updateQuantity } = useCartActions({
    selectedProductslist,
    setSelectedProductslist,
    setValueMap,
    setCondition,
    setEditedAmounts, // Pass setter
    editedAmounts,
  });

  // Effect to handle delivery fee validation
  useEffect(() => {
    if (totalAmount === 0 && deliveryFee !== 0) {
      setDeliveryFee(0);
      return;
    }

    // if (deliveryFee >= totalAmount && totalAmount > 0) {
    //   setDeliveryFee(0);
    // }
  }, [totalAmount, deliveryFee, setDeliveryFee]);

  // Update product amount
  const updateProductAmount = useCallback((productId: string, newAmount: string) => {
    // Store the edited amount separately
    setEditedAmounts(prev => ({
      ...prev,
      [productId]: newAmount
    }));
  }, [setEditedAmounts]);

  // Reset cart function
  const resetCart = useCallback(() => {
    setSelectedProductslist([]);
    setValueMap({});
    setCondition(0);
    setDeliveryFee(0);
    setEditedAmounts({}); // Clear edited amounts
  }, [setSelectedProductslist, setValueMap, setCondition, setDeliveryFee, setEditedAmounts]);

  // Get the display amount for a product (edited amount or original)
  const getProductDisplayAmount = useCallback((productId: string, originalAmount: string) => {
    return editedAmounts[productId] || originalAmount;
  }, [editedAmounts]);

  return {
    selectedProductslist,
    valueMap,
    totalQuantity,
    totalAmount,
    condition,
    disValue,
    grandTotal,
    setCondition,
    deliveryFee,
    setDeliveryFee,
    addProductToCart,
    removeProductFromCart,
    updateQuantity,
    resetCart,
    updateProductAmount,
    getProductDisplayAmount, // Export this helper
    editedAmounts, // Export for use in components
  };
};